<app-dialog-container
  title="cartMergeStrategy"
  confirmButtonText="applyCartItems"
  [isValid]="strategyControl.valid"
  (confirmButtonHandler)="confirm()"
>
  <div class="cart-merge-strategy">
    <p>
      {{ 'cartMergeStrategyDescription' | translate: { count: data.overlapCount } }}
    </p>

    <mat-radio-group class="cart-merge-strategy-options" [formControl]="strategyControl">
      <mat-radio-button [value]="strategies.KeepDraftQuantities">
        {{ 'keepDraftQuantities' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="strategies.ReplaceWithCartQuantities">
        {{ 'replaceWithCartQuantities' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="strategies.MergeQuantities">
        {{ 'mergeQuantities' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</app-dialog-container>
